<template>
  <div class="content--sinoreg">
    <header>
      <h4 class="improvementsSystemUpdatesTitle py-3 pl-3">
        Atualizações do sistema
      </h4>
    </header>

    <div class="input-group my-4 d-flex justify-content-between">
      <div class="inputContainer">
        <input v-model="searchInputText"
               placeholder="Digite o número da versão..."
               trim
               type="text"
               class="form-control">
      </div>
      <button type="button"
              class="btnSearch btn"
              :disabled="!searchInputText"
              @click="getDataPassedByInput">
        Pesquisar
      </button>
    </div>
    <hr class="dividingLine my-4">

    <div class="input-group mt-3">
      <div class="mr-4">
        <label for="radio-group"
               class="label">
          Mostrar atualizações:
        </label>
        <div class="mt-2">
          <b-form-group>
            <b-form-radio-group
              id="radio-group"
              v-model="selectedCategory"
              :options="radioOptionsItems"
              name="radio-options" 
              @input="getReleasesByCategories" />
          </b-form-group>
        </div>
      </div>

      <div class="form-group w-25">
        <label for="subcategoria"
               class="label">
          Subcategoria
        </label>
        <v-select id="subcategoria"
                  v-model="selectedSubcategory"
                  class="w-75 mt-2"
                  :reduce="subcategoriesItem => subcategoriesItem.value"
                  :options="subcategoriesItems"
                  :searchable="false"
                  @input="getReleasesBySubcategories" />
      </div>
    </div>

    <div class="pl-2">
      <div>
        <h5 class="lastImprovementsTitle">
          Últimas Atualizações
        </h5>
      </div>
      <div class="lastImprovementsContainer">
        <div v-for="(dados, index) of displaySystemUpdates"
             :key="index">
          <p class="mt-3 mb-0 text-primary"
             role="button" 
             @click="goToImprovements(dados)">
            <u>Atualização {{ dados.num_versao }} - {{ formattedDate (dados.created_at) }}</u>
          </p>
          <p class="w-50 text-truncate">
            {{ dados.resumo }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex"

  // outros
  import moment from 'moment'

  /* services */
  import ReleasesNotesService from "@/services/ReleasesNotes"

  /* utils */
  import { saveReleaseNotesData } from '@/utils/releasesNotes'

  export default {
    name: 'LastUpdates',
    data () {
      return {
        searchInputText: null,
        selectedCategory: 'todos(categorias)',
        selectedSubcategory: 'Todos',
        displaySystemUpdates: null,
        radioOptionsItems: [
          { text: 'Todos', value: 'todos(categorias)'},
          { text: 'Melhorias', value: 'melhorias'},
          { text: 'Correções', value: 'correcoes'},
          { text: 'Novas funcionalidades', value: 'novas_funcionalidades'},
          { text: 'Outros', value: 'outros(categorias)'}
        ],
        subcategoriesItems: []
      }
    },
    computed: {
      ...mapGetters({
        storeReleases: 'releasesNotes/getReleases',
        qtdUnreadEntries: 'releasesNotes/getNumberUnreadReleases'
      })
    },
    created () {
      this.init ()
    },
    methods: {
      async init () {
        try {
          // Popular a tela com todas as últimas atualizações
          this.displaySystemUpdates = [...this.storeReleases]
          this.displaySystemUpdates.reverse()
      
          // Buscar todas as Subcategorias
          const dataFromApi = await ReleasesNotesService.getAllSubcategory() 
          this.subcategoriesItems =  this.formattingSubcategoryData (dataFromApi)
        } catch (error) {
          this.errorMessage (error)
        }
      },
      async getDataPassedByInput () {
        try {
          const dataFromApi = await ReleasesNotesService.getRelease(this.searchInputText.trim())
          this.displaySystemUpdates = dataFromApi
          this.searchInputText = null

        } catch (error) {
          this.errorMessage (error)
        }
      },
      async getReleasesByCategories () {
        try {
          const dataFromApi = await ReleasesNotesService.getReleasesByCategory(this.selectedCategory)
          this.displaySystemUpdates = dataFromApi

        } catch (error) {
          this.errorMessage (error)
        }
      },
      async getReleasesBySubcategories () {
        try {
          const dataFromApi = await ReleasesNotesService.getReleasesBySubcategory(this.selectedSubcategory)
          this.displaySystemUpdates = dataFromApi

        } catch (error) {
          this.errorMessage (error)
        }
      },
      async goToImprovements (improvements) {
        try {
          improvements.read = true
          document.getElementById("notificacoes").checked = false
          saveReleaseNotesData (improvements)

          this.$router
            .push({ name: 'releases-notes', params: {id: improvements.versao_sofia_rei_id, data: improvements}})
            .catch(() => this.$router.push('/'))
        } catch (error) {
          this.errorMessage (error)
        }
      },
      formattedDate (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      formattingSubcategoryData (data) {
        return data
          .reduce((acc, valorAtual) => {
            const treatingTheString = valorAtual.nome_subcategoria
              .replace(/_/g, ' ')
              .replace(/\s\w/g, char => char.toUpperCase())

            acc.push({ value: valorAtual.nome_subcategoria, label: treatingTheString})
            return acc
          }, [])
      },
      errorMessage (error) {
        objSwal.error.title = ''
        objSwal.error.text = error.message
        objSwal.error.html = ''
        Swal.fire(objSwal.error)
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";
.improvementsSystemUpdatesTitle {
   background-color: #074F7F;
   color: #ffffff;
   font-weight: 500;
}
.inputContainer{
  width: 90%;
}
.btnSearch {
  background-color: #C6C6C6;
  color: #000000;

  &:hover {
    background-color: #b2b2b2;
    color: #ffffff;
  }
}

.dividingLine {
  border: 1px solid #086AAE;
}

.lastImprovementsTitle {
  font-weight: 500;
}

.lastImprovementsContainer {
  overflow: auto;
  max-height: 20rem;
}
</style>
